import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const ButtonA = styled.a`
  height: ${(p) => (p.height ? p.height : '48px')};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) => (p.background ? p.background : Colors.planoplan_blue)};
  font-size: inherit;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${Colors.white};
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: background-color 0.1s;
  text-decoration: none;
  &:hover {
    background-color: ${(p) => (p.background ? p.background : Colors.electric_blue)};
    color: ${Colors.white};
  }
`;
